// extracted by extract-css-chunks-webpack-plugin
module.exports = {"AVATAR_SIZE":"80px","authorImageContainer":"_3kGzMs","image":"lIFQou","imageWrapper":"_3PsbUw"};